import styled, { css } from 'styled-components';

const PlayButtonStyled = styled.button`
  ${({ isLoading }: { isLoading?: boolean }) => {
    return css`
      width: 3em;
      height: 3em;
      background: var(--color-teal);
      border: none;
      position: relative;
      border-radius: 50%;
      &:hover {
        background: var(--color-teal-darkest);
      }
      &:disabled {
        background: var(--tertiary-border-color);
      }
      .play-button__loading-spinner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .play-button__icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      ${isLoading &&
      css`
        background: transparent;
        &:hover {
          background: transparent;
          cursor: not-allowed;
        }
        .play-button__icon path {
          fill: transparent;
          stroke: var(--color-white);
          strokewidth: 0.125em;
        }
      `}
    `;
  }}
`;

export default PlayButtonStyled;
